/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useUpdateERA
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for update ERA
 *
 */
interface IProps {
	requestParams: ERA.ERAPatchModel;
}
const useUpdateERA = (): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ requestParams }) => {
			const { data } = await api.PaymentReconciliationApi.patchEraPaymentReconciliation(requestParams);
			return data;
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.eraDetails] });
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.allERAs] });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useUpdateERA;
